<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="GoodsPriceId"
      ref="list"
      unit="存货销售价"
      :expand-all-row="true"
      :page="true"
      :show-checkbox="true"
      :show-query="false"
      :query-params="params"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/business/sales/saleprice/list.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sa/goodsPrice").default,
      tableList: [],
      params: {
        ProductName: "",
        ProductNo: "",
      },
    };
  },
  methods: {
    onExport(params={}) {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
